import { NgModule } from '@angular/core';

import { UppKonvaComponent } from './component/upp-konva-component';
import { UppKonvaFloorPlanBridgeModule } from './upp-konva-floor-plan-bridge.module';

@NgModule({
  imports: [UppKonvaFloorPlanBridgeModule],
  declarations: [UppKonvaComponent],
  /** Public exports of the UppKonva component. */
  exports: [UppKonvaComponent],
})
export class UppKonvaModule {}
